export default __webpack_public_path__ + "static/media/rose.7669c2b8.svg";